export default __webpack_public_path__ + "static/media/s1.5870c6bd.jpg";